var _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g2, _rect10, _rect11, _rect12, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 132,
    viewBox: "0 0 298 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_121_41930)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 234,
    height: 60,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6868fe",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_41930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 26,
    width: 16,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_41930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 38V36.95C42 36.4611 42.2473 36.0693 42.742 35.7747C43.2362 35.4804 43.8778 35.3333 44.6667 35.3333C44.8111 35.3333 44.95 35.336 45.0833 35.3413C45.2167 35.3471 45.3444 35.3611 45.4667 35.3833C45.3111 35.6056 45.1944 35.8444 45.1167 36.1C45.0389 36.3556 45 36.6278 45 36.9167V38H42ZM46 38V36.9167C46 36.1944 46.3696 35.6111 47.1087 35.1667C47.8473 34.7222 48.8111 34.5 50 34.5C51.2 34.5 52.1667 34.7222 52.9 35.1667C53.6333 35.6111 54 36.1944 54 36.9167V38H46ZM55 38V36.9167C55 36.6278 54.9638 36.3556 54.8913 36.1C54.8193 35.8444 54.7111 35.6056 54.5667 35.3833C54.6889 35.3611 54.814 35.3471 54.942 35.3413C55.0696 35.336 55.2 35.3333 55.3333 35.3333C56.1333 35.3333 56.7778 35.4804 57.2667 35.7747C57.7556 36.0693 58 36.4611 58 36.95V38H55ZM50 35.8333C49.3667 35.8333 48.8 35.9167 48.3 36.0833C47.8 36.25 47.5056 36.4444 47.4167 36.6667H52.6C52.5 36.4444 52.2027 36.25 51.708 36.0833C51.2138 35.9167 50.6444 35.8333 50 35.8333ZM44.6667 34.6667C44.3 34.6667 43.9862 34.536 43.7253 34.2747C43.464 34.0138 43.3333 33.7 43.3333 33.3333C43.3333 32.9556 43.464 32.6389 43.7253 32.3833C43.9862 32.1278 44.3 32 44.6667 32C45.0444 32 45.3611 32.1278 45.6167 32.3833C45.8722 32.6389 46 32.9556 46 33.3333C46 33.7 45.8722 34.0138 45.6167 34.2747C45.3611 34.536 45.0444 34.6667 44.6667 34.6667ZM55.3333 34.6667C54.9667 34.6667 54.6527 34.536 54.3913 34.2747C54.1304 34.0138 54 33.7 54 33.3333C54 32.9556 54.1304 32.6389 54.3913 32.3833C54.6527 32.1278 54.9667 32 55.3333 32C55.7111 32 56.0278 32.1278 56.2833 32.3833C56.5389 32.6389 56.6667 32.9556 56.6667 33.3333C56.6667 33.7 56.5389 34.0138 56.2833 34.2747C56.0278 34.536 55.7111 34.6667 55.3333 34.6667ZM50 34C49.4444 34 48.9722 33.8056 48.5833 33.4167C48.1944 33.0278 48 32.5556 48 32C48 31.4333 48.1944 30.9582 48.5833 30.5747C48.9722 30.1916 49.4444 30 50 30C50.5667 30 51.0416 30.1916 51.4247 30.5747C51.8082 30.9582 52 31.4333 52 32C52 32.5556 51.8082 33.0278 51.4247 33.4167C51.0416 33.8056 50.5667 34 50 34ZM50 31.3333C49.8111 31.3333 49.6529 31.3971 49.5253 31.5247C49.3973 31.6527 49.3333 31.8111 49.3333 32C49.3333 32.1889 49.3973 32.3471 49.5253 32.4747C49.6529 32.6027 49.8111 32.6667 50 32.6667C50.1889 32.6667 50.3473 32.6027 50.4753 32.4747C50.6029 32.3471 50.6667 32.1889 50.6667 32C50.6667 31.8111 50.6029 31.6527 50.4753 31.5247C50.3473 31.3971 50.1889 31.3333 50 31.3333Z",
    fill: "#6868fe",
    fillOpacity: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 20.5,
    width: 144,
    height: 10,
    rx: 4,
    fill: "#6868fe",
    fillOpacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 37.5,
    width: 105,
    height: 10,
    rx: 4,
    fill: "#6868fe",
    fillOpacity: 0.12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 233,
    height: 59,
    rx: 3.5,
    stroke: "#6868fe",
    strokeOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_121_41930)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 56,
    width: 234,
    height: 60,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 70,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#6868fe",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_121_41930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 78,
    width: 16,
    height: 16
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 78,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_121_41930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 90V88.95C86 88.4611 86.2473 88.0693 86.742 87.7747C87.2362 87.4804 87.8778 87.3333 88.6667 87.3333C88.8111 87.3333 88.95 87.336 89.0833 87.3413C89.2167 87.3471 89.3444 87.3611 89.4667 87.3833C89.3111 87.6056 89.1944 87.8444 89.1167 88.1C89.0389 88.3556 89 88.6278 89 88.9167V90H86ZM90 90V88.9167C90 88.1944 90.3696 87.6111 91.1087 87.1667C91.8473 86.7222 92.8111 86.5 94 86.5C95.2 86.5 96.1667 86.7222 96.9 87.1667C97.6333 87.6111 98 88.1944 98 88.9167V90H90ZM99 90V88.9167C99 88.6278 98.9638 88.3556 98.8913 88.1C98.8193 87.8444 98.7111 87.6056 98.5667 87.3833C98.6889 87.3611 98.814 87.3471 98.942 87.3413C99.0696 87.336 99.2 87.3333 99.3333 87.3333C100.133 87.3333 100.778 87.4804 101.267 87.7747C101.756 88.0693 102 88.4611 102 88.95V90H99ZM94 87.8333C93.3667 87.8333 92.8 87.9167 92.3 88.0833C91.8 88.25 91.5056 88.4444 91.4167 88.6667H96.6C96.5 88.4444 96.2027 88.25 95.708 88.0833C95.2138 87.9167 94.6444 87.8333 94 87.8333ZM88.6667 86.6667C88.3 86.6667 87.9862 86.536 87.7253 86.2747C87.464 86.0138 87.3333 85.7 87.3333 85.3333C87.3333 84.9556 87.464 84.6389 87.7253 84.3833C87.9862 84.1278 88.3 84 88.6667 84C89.0444 84 89.3611 84.1278 89.6167 84.3833C89.8722 84.6389 90 84.9556 90 85.3333C90 85.7 89.8722 86.0138 89.6167 86.2747C89.3611 86.536 89.0444 86.6667 88.6667 86.6667ZM99.3333 86.6667C98.9667 86.6667 98.6527 86.536 98.3913 86.2747C98.1304 86.0138 98 85.7 98 85.3333C98 84.9556 98.1304 84.6389 98.3913 84.3833C98.6527 84.1278 98.9667 84 99.3333 84C99.7111 84 100.028 84.1278 100.283 84.3833C100.539 84.6389 100.667 84.9556 100.667 85.3333C100.667 85.7 100.539 86.0138 100.283 86.2747C100.028 86.536 99.7111 86.6667 99.3333 86.6667ZM94 86C93.4444 86 92.9722 85.8056 92.5833 85.4167C92.1944 85.0278 92 84.5556 92 84C92 83.4333 92.1944 82.9582 92.5833 82.5747C92.9722 82.1916 93.4444 82 94 82C94.5667 82 95.0416 82.1916 95.4247 82.5747C95.8082 82.9582 96 83.4333 96 84C96 84.5556 95.8082 85.0278 95.4247 85.4167C95.0416 85.8056 94.5667 86 94 86ZM94 83.3333C93.8111 83.3333 93.6529 83.3971 93.5253 83.5247C93.3973 83.6527 93.3333 83.8111 93.3333 84C93.3333 84.1889 93.3973 84.3471 93.5253 84.4747C93.6529 84.6027 93.8111 84.6667 94 84.6667C94.1889 84.6667 94.3473 84.6027 94.4753 84.4747C94.6029 84.3471 94.6667 84.1889 94.6667 84C94.6667 83.8111 94.6029 83.6527 94.4753 83.5247C94.3473 83.3971 94.1889 83.3333 94 83.3333Z",
    fill: "#6868fe",
    fillOpacity: 0.5
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 72.5,
    width: 144,
    height: 10,
    rx: 4,
    fill: "#6868fe",
    fillOpacity: 0.12
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 89.5,
    width: 105,
    height: 10,
    rx: 4,
    fill: "#6868fe",
    fillOpacity: 0.12
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 56.5,
    width: 233,
    height: 59,
    rx: 3.5,
    stroke: "#6868fe",
    strokeOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_121_41930",
    x: 0,
    y: 0,
    width: 254,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_41930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_41930",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_121_41930",
    x: 44,
    y: 52,
    width: 254,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_121_41930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_121_41930",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeams);
export default __webpack_public_path__ + "static/media/no-teams.6d488bd434cd3b62425d27dd64179c54.svg";
export { ForwardRef as ReactComponent };